import * as React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import "./CommonDashboard.css";
import { useSelector, useDispatch } from "react-redux";
import QRCode from "qrcode.react";
import { QrReader } from "react-qr-reader";
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import {
  Dialog,
  DialogContent,
  MenuItem,
  Paper,
  Stack,
  TextField,
} from "@mui/material";
import { Modal, Button } from "@mui/material";

import ConfirmationDialog from "./ConfirmationDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import { CssBaseline, DialogTitle } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import EditIcon from "@material-ui/icons/Edit";
import { setScreenuser } from "../redux/slices/screenusersSlice";
import EditScreenUserForm from "./EditScreenUserForm";
import EmmActionMenu from "./EmmActionMenu";
import EmmResponseModal from "./EmmResponseModal";
import { toast } from "react-toastify";
import { encryptWithPassword } from "./helpers/ChangePassword/encrypt";
import TableStatus from "./TableStatus";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "#e0e0e0",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-cell": {
      fontWeight: "normal",
      fontSize: "0.875rem",
      color: "rgba(0, 0, 0, 0.87)",
      letterSpacing: "0.01071em",
    },
    "& .MuiDataGrid-cell--textLeft": {
      textAlign: "left",
    },
    "& .MuiDataGrid-cell--textCenter": {
      textAlign: "center",
    },
    "& .MuiDataGrid-cell--textRight": {
      textAlign: "right",
    },
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
  },
  table: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: `calc(100% - ${theme.spacing(9)}px)`,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "relative ",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    alignItems: "center",
    marginTop: "10%",
    borderRadius: "5px",
  },
}));

const Screenuser = ({ selectedOption, responseData, errors, isLoading }) => {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const api = localStorage.getItem("api");
  const emms = useSelector((state) => state?.emms);
  const screenusers = useSelector((state) => state?.screenusers);
  const headers = useSelector((state) => state?.header);

  const [open, setOpen] = React.useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const emmsheaders = useSelector((state) => state?.emmsheader);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [loadingResponseId, setLoadingResponseId] = useState(null);
  const emmScreenusersIds = useSelector(
    (state) => state?.emmConfig?.emmScreenuserIds
  );

  const [emmResponses, setEmmResponses] = useState({});
  const [selectedResponseId, setSelectedResponseId] = useState(null);
  const [QABURL, setQABURL] = useState("");
  const [openScanner, setOpenScanner] = useState(false);
  const [scannedData, setScannedData] = useState(null);
  const [currentScreenuser, setCurrentScreenuser] = useState(null);
  const [showScanner, setShowScanner] = React.useState(false);
  const scanningLock = useRef(false);
  const [scannerStatus, setScannerStatus] = useState("Waiting for QR code...");
  const hasScanned = React.useRef(false);
  const [cameraAccessDenied, setCameraAccessDenied] = useState(false);
  const [formData, setFormData] = useState({
    qab: "",
    qabUrl: "",
    rluId: "",
  });
  const streamRef = useRef(null)
  const closeResponseModal = () => {
    setSelectedResponseId(null);
    setEmmResponses({});
  };
  const handleCloseScanner = () => {
    setOpenScanner(false);
    setShowScanner(false);
    setScannedData(null);
    setQABURL(null);
    hasScanned.current = false;
    scanningLock.current = false;
    setFormData({
      qab: "",
      qabUrl: "",
      rluId: "",
    });
  };


  const cameraLock = useRef(Promise.resolve());

  useEffect(() => {
    if (!openScanner) {
      cameraLock.current = cameraLock.current.then(() => {
        if (streamRef.current) {
          streamRef.current.getTracks().forEach((t) => t.stop());
          streamRef.current = null;
        }
        setShowScanner(false);
      });
      return;
    }

    let cancelled = false;

    hasScanned.current = false;
    scanningLock.current = false;
    setScannedData(null);
    setScannerStatus("Waiting for QR code...");
    setShowScanner(true);

    if (!window.isSecureContext && window.location.hostname !== "localhost") {
      setCameraAccessDenied(true);
      return;
    }

    cameraLock.current = cameraLock.current
      .then(() => {
      
        if (streamRef.current) {
          streamRef.current.getTracks().forEach((t) => t.stop());
          streamRef.current = null;
        }
      })
      .then(() => {
        if (cancelled) return;
        return navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" },
        });
      })
      .then((stream) => {
        if (!stream) return;
        if (cancelled) {
          stream.getTracks().forEach((t) => t.stop());
          return;
        }
        streamRef.current = stream;
        setCameraAccessDenied(false);
      })
      .catch((err) => {
        if (cancelled) return;
        console.error("Camera error:", err);

        if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
          setCameraAccessDenied(true);
        } else if (err.name === "NotReadableError") {
          setScannerStatus("Camera is in use by another app. Please close it and try again.");
        } else {
          setScannerStatus(`Camera error: ${err.message}`);
        }
      });

    return () => {
      cancelled = true;
      cameraLock.current = cameraLock.current.then(() => {
        if (streamRef.current) {
          streamRef.current.getTracks().forEach((t) => t.stop());
          streamRef.current = null;
        }
      });
    };
  }, [openScanner]);

  const handleOpenScanner = (row) => {
    setCurrentScreenuser(row);
    hasScanned.current = false;
    setOpenScanner(true);
  };

  const handleScan = async (result, error) => {
    if (!result?.text || scanningLock.current) return;

    scanningLock.current = true;
    hasScanned.current = true;
    setScannerStatus("Processing QR code...");

    try {
      const parsedData = JSON.parse(result.text);
      setScannedData(result.text);
      setQABURL(parsedData?.qabUrl);

      const rluId = parsedData.rluId;
      const urlObj = new URL(parsedData.qabUrl);
      const scannedHost = urlObj.hostname;
      const scannedPort = urlObj.port || "";

      const matchedServer = emms?.emms?.find(
        (server) =>
          server.ipAddress.toLowerCase().includes(scannedHost.toLowerCase()) &&
          server.portNumber.toString() === scannedPort.toString()
      );

      if (matchedServer) {
        setScannerStatus("Backend matched. Logging in...");
        await performLogin(matchedServer, rluId);
        setScannerStatus("Login complete. Updating QAB...");
      } else {
        throw new Error("Backend Address NOT FOUND");
      }
    } catch (err) {
      console.error("Failed to process QR:", err);
      toast.error(err.message || "Invalid QR Code");
    } finally {
      handleCloseScanner();
    }
  };
  const handleManualLogin = async () => {
    scanningLock.current = true;
    hasScanned.current = true;
    setScannerStatus("Processing QR code...");
    try {
      setQABURL(formData?.qabUrl);

      const rluId = formData.rluId;
      const urlObj = new URL(formData.qabUrl);
      const scannedHost = urlObj.hostname;
      const scannedPort =
        urlObj.port || (urlObj.protocol === "https:" ? "443" : "80");

      const matchedServer = emms?.emms?.find(
        (server) =>
          server.ipAddress.toLowerCase().includes(scannedHost.toLowerCase()) &&
          server.portNumber.toString() === scannedPort.toString()
      );

      if (matchedServer) {
        setScannerStatus("Backend matched. Logging in...");
        await performLogin(matchedServer, rluId);
        setScannerStatus("Login complete. Updating QAB...");
      } else {
        throw new Error("Backend Address NOT FOUND");
      }
    } catch (err) {
      console.error("Failed to process QR:", err);
      toast.error(err.message || "Invalid QR Code");
    } finally {
      handleCloseScanner();
    }
  };
  const handleQabUpdate = async (
    authSecret,
    currentScreenuser,
    emmsId,
    tesId,
    rluId
  ) => {
    const screenuser = {
      id: currentScreenuser,
      screenUserName: currentScreenuser.screenUserName,
      screenUserPassword: currentScreenuser.screenUserPassword,
    };

    if (!authSecret || typeof authSecret !== "string" || !authSecret.trim()) {
      console.error("authSecret is empty or invalid");
      return;
    }
    const encodedBody = await encryptWithPassword(screenuser, authSecret);

    try {
      const requestBody = {
        path: "security/updateQab",
        query: {},
        body: {
          rlu: rluId,
          tesId: tesId,
          authToken: encodedBody,
        },
        emmsId: `${emmsId}`,
        requestType: "POST",
        headers: emmsheaders?.emmsheaders?.headers,
      };

      await axios
        .post(api + "/emms/piggyback", requestBody, headers)
        .then((response) => {
          if (response.status == "200")
            toast.success("Login Successful", {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
        })
        .catch((error) => {
          toast.error(error, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        });
      handleCloseScanner();
    } catch (error) {
      toast.error("Login Failed", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      console.log(error);
      throw error;
    }
  };
  const performLogin = async (matchedEmms, rluId) => {
    try {
      const emmsId = matchedEmms?.id;
      const requestBody = {
        path: "security/tes",
        query: {},
        emmsId: `${emmsId}`,
        requestType: "GET",
        headers: emmsheaders?.emmsheaders?.headers,
      };

      axios
        .post(api + "/emms/piggyback", requestBody, headers)
        .then((response) => {
          const tesId = response.data?.id;
          const authSecret = response?.data?.authSecret;
          handleQabUpdate(authSecret, currentScreenuser, emmsId, tesId, rluId);
        })
        .catch((error) => {
          toast.error("Erroe getting TES token", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          console.log(error);
        });
    } catch (error) {
      throw error;
    }
  };
  const handleError = (err) => {
    console.error("QR Scanner error:", err);
    setScannerStatus("Scanner error — please try again.");
    toast.error("Scanner error: " + (err.message || err.toString()));

    setOpenScanner(false);
    hasScanned.current = false;
  };
  const handleEdit = (id) => {
    setSelectedItemId(id);
  };
  const handleEmmAction = async (row, operation) => {
    setSelectedResponseId(row.id);
    setLoadingResponseId(row.id);
    try {
      const json = {
        screenuserIds: [row?.id],
        operation,
      };
      const requestBody = {
        path: "emm",
        query: {},
        emmsId: selectedOption,
        body: { ...json },
        requestType: "POST",
        headers: emmsheaders?.emmsheaders?.headers,
      };

      const response = await axios.post(
        api + `/emms/piggyback`,
        requestBody,
        headers
      );

      const result = response.data;

      const deviceResult = result[row.id];

      if (operation.includes("getScreenshot") && deviceResult?.success) {
      
        setEmmResponses((prev) => ({
          ...prev,
          [row.id]: {
            ...deviceResult,
            raw: result, 
          },
        }));
      } else {
      
        setEmmResponses((prev) => ({
          ...prev,
          [row.id]: {
            ...deviceResult,
            raw: result, 
          },
        }));
      }
    } catch (err) {
      console.error("Failed EMM op:", err);
    } finally {
      setLoadingResponseId(null);
    }
  };
  const safeRows = Array.isArray(rows) ? rows : [];
  const safeEmmScreenusersIds = Array.isArray(emmScreenusersIds)
    ? emmScreenusersIds
    : [];

  const isAnyRowAllowed = safeRows.some((row) =>
    safeEmmScreenusersIds.includes(row.id)
  );
  const columns = [
    {
      field: "screenUserName",
      headerName: "ScreenUser Name",
      width: 120,
    },
    {
      field: "screenUserPassword",
      headerName: "ScreenUser Password",
      width: 120,
    },

    {
      field: "typeOfScreen",
      headerName: "Type Of Screen",

      width: 150,
    },

    {
      field: "qrCode",
      headerName: "QR Code",
      width: 150,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="success"
          onClick={() => handleOpenScanner(params.row)}
        >
          QR Code
        </Button>
      ),
    },
    ,
    {
      field: "delete",
      headerName: "Delete",
      width: 150,
      renderCell: (params) => (
        <Button
          variant="outlined"
          startIcon={<DeleteIcon />}
          color="error"
          onClick={() => handleDelete(params.row.id)}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      ),
    },
    {
      field: "edit",
      headerName: "Edit",
      width: 100,
      renderCell: (params) => (
        <Button
          variant="outlined"
          startIcon={<EditIcon />}
          color="primary"
          onClick={() => handleEdit(params.row.id)}
          disabled={loading}
        >
          {loading ? "Editing..." : "Edit"}
        </Button>
      ),
    },
    ...(isAnyRowAllowed
      ? [
        {
          field: "emmActions",
          headerName: "Remote Actions",
          width: 150,
          renderCell: (params) => {
            const isAllowed = emmScreenusersIds?.includes(params.row.id);
            return isAllowed ? (
              <EmmActionMenu row={params.row} onAction={handleEmmAction} />
            ) : null;
          },
          sortable: false,
          filterable: false,
        },
      ]
      : []),
    {
      field: "meeting_room_name",
      headerName: "Meeting Room",
      width: 300,
    },

    {
      field: "customisation_name",
      headerName: "Customisation",
      width: 300,
    },
    {
      field: "location_name",
      headerName: "Location",
      width: 300,
    },
    {
      field: "lastloginip",
      headerName: "Last Login IP",
      width: 120,
    },
    {
      field: "ratio",
      headerName: "Rooms Configured",
      width: 150,
      valueGetter: (params) => {
        const customProperties = params?.row?.customProperties;
        if (!customProperties) {
          return "N/A";
        }

        const totalMRCount = customProperties?.totalMRCount || 0;
        const meetingSpaceDirectionsCount =
          customProperties?.MeetingSpaceDirections
            ? Object.keys(customProperties?.MeetingSpaceDirections)?.length
            : 0;

        if (totalMRCount === 0) {
          return "N/A";
        }

        return `${meetingSpaceDirectionsCount}/${totalMRCount}`;
      },
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleDelete = (id) => {
    setDeleteItemId(id);
    setShowConfirmationDialog(true);
  };

  const handleConfirmDelete = () => {
    setShowConfirmationDialog(false);
    setLoading(true);
    const requestBody = {
      path: "screenusers",
      query: {  screenid: `${deleteItemId}` },
      emmsId: selectedOption,
      body: {},
      requestType: "DELETE",
      headers: emmsheaders.emmsheaders?.headers,
    };

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then(() => {
        setRows((prevRows) => {
          const updatedRows = prevRows.filter((row) => row.id !== deleteItemId);
          dispatch(setScreenuser(updatedRows));
          return updatedRows;
        });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancelDelete = () => {
    setShowConfirmationDialog(false);
  };

  React.useEffect(() => {
    setRows(Array.isArray(screenusers.screenusers) ? screenusers.screenusers : []);
  }, [screenusers.screenusers, emmScreenusersIds]);

  return (
    <>
      {rows?.length > 0 && errors === false ? (
        <>
          <CssBaseline>
            <ThemeProvider>
              <div className="emms-data-grid-container" style={{ padding: "2.5% 10%" }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  pageSizeOptions={[5]}
                  checkboxSelection
                  disableRowSelectionOnClick
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                    },
                  }}
                />
              </div>
              <Dialog
                open={openScanner}
                onClose={handleCloseScanner}
                fullWidth
                maxWidth="xs"
              >
                <DialogTitle>Scan QR Code</DialogTitle>
                <DialogContent>
                  {!hasScanned.current &&
                    !cameraAccessDenied &&
                    openScanner && (
                      <QrReader
                        key={openScanner ? "scanner-on" : "scanner-off"}
                        constraints={{ facingMode: "environment" }}
                        onResult={handleScan}
                        onError={handleError}
                        style={{ width: "100%" }}
                        scanDelay={1500}
                      />
                    )}

                  {cameraAccessDenied && (
                    <>
                      <p>
                        Camera access was denied or unavailable. Please fill in
                        the details manually:
                      </p>
                      <TextField
                        fullWidth
                        label="QAB"
                        name="qab"
                        value={formData.qab}
                        onChange={handleChange}
                        select
                        margin="normal"
                      >
                        <MenuItem value="ECB">ECB</MenuItem>
                        <MenuItem value="EMMS">EMMS</MenuItem>
                      </TextField>
                      <TextField
                        fullWidth
                        label="QAB URL"
                        name="qabUrl"
                        value={formData.qabUrl}
                        onChange={handleChange}
                        margin="normal"
                      />
                      <TextField
                        fullWidth
                        label="RLUID"
                        name="rluId"
                        value={formData.rluId}
                        onChange={handleChange}
                        margin="normal"
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleManualLogin()}
                      >
                        Login
                      </Button>
                    </>
                  )}

                  {scannedData && (
                    <p style={{ marginTop: 16 }}>Scanned Data: {scannedData}</p>
                  )}
                </DialogContent>
              </Dialog>

              {selectedItemId !== null && (
                <EditScreenUserForm
                  screenUserData={screenusers.screenusers}
                  selectedOption={selectedOption}
                  selectedItemId={selectedItemId}
                  handleClose={() => setSelectedItemId(null)}
                />
              )}
              {showConfirmationDialog && (
                <ConfirmationDialog
                  open={showConfirmationDialog}
                  onClose={handleCancelDelete}
                  onConfirm={handleConfirmDelete}
                />
              )}

              <EmmResponseModal
                isOpen={!!selectedResponseId}
                onClose={closeResponseModal}
                response={emmResponses[selectedResponseId]}
                isLoading={loadingResponseId === selectedResponseId}
              />
            </ThemeProvider>
            <Modal
              open={openModal}
              onClose={() => setOpenModal(false)}
              className={classes.modal}
            >
              <div
                className={classes.paper}
                style={{
                  marginRight: "60%",
                  marginTop: "30%",
                }}
              >
                <QRCode
                  value={`${selectedRow?.screenUserName}:${selectedRow?.screenUserPassword}:${selectedRow?.ipAddress}:${selectedRow?.port}`}
                  size={200}
                />
                <div className="qrcode">
                  Username :{selectedRow?.screenUserName}
                  <br />
                  Password :{selectedRow?.screenUserPassword}
                  <br />
                  IP Address: {selectedRow?.ipAddress}
                  <br />
                  Port: {selectedRow?.port}
                </div>
              </div>
            </Modal>
          </CssBaseline>
        </>
      ) : (
        <TableStatus loading={isLoading} errors={errors} />
      )}
    </>
  );
};

export default Screenuser;
